module.exports = __webpack_public_path__ + "img/Hotel Kitzhof_Zimmer-Suiten-Studios_2.jpg";